import React, { useEffect, useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles({
  cursorDot: {
    width: 8,
    height: 8,
    backgroundColor: '#2DAA67',
    borderRadius: '50%',
    position: 'fixed',
    pointerEvents: 'none',
    zIndex: 9999,
    transform: 'translate(-50%, -50%)',
    transition: 'width 0.2s, height 0.2s, background-color 0.2s'
  },
  cursorOutline: {
    width: 40,
    height: 40,
    border: '2px solid rgba(45, 170, 103, 0.4)',
    borderRadius: '50%',
    position: 'fixed',
    pointerEvents: 'none',
    zIndex: 9998,
    transform: 'translate(-50%, -50%)',
    transition: 'all 0.15s ease-out'
  },
  '@global': {
    'a, button, input, textarea, [role="button"], .MuiButtonBase-root': {
      cursor: 'none !important'
    },
    'body': {
      cursor: 'none'
    }
  }
})

const CustomCursor = () => {
  const classes = useStyles()
  const [position, setPosition] = useState({ x: 0, y: 0 })
  const [clicked, setClicked] = useState(false)
  const [linkHovered, setLinkHovered] = useState(false)
  const [hidden, setHidden] = useState(true)

  useEffect(() => {
    const addEventListeners = () => {
      document.addEventListener('mousemove', onMouseMove)
      document.addEventListener('mouseenter', onMouseEnter)
      document.addEventListener('mouseleave', onMouseLeave)
      document.addEventListener('mousedown', onMouseDown)
      document.addEventListener('mouseup', onMouseUp)
    }

    const removeEventListeners = () => {
      document.removeEventListener('mousemove', onMouseMove)
      document.removeEventListener('mouseenter', onMouseEnter)
      document.removeEventListener('mouseleave', onMouseLeave)
      document.removeEventListener('mousedown', onMouseDown)
      document.removeEventListener('mouseup', onMouseUp)
    }

    const onMouseMove = (e) => {
      setPosition({ x: e.clientX, y: e.clientY })
      setHidden(false)
    }

    const onMouseEnter = () => setHidden(false)
    const onMouseLeave = () => setHidden(true)
    const onMouseDown = () => setClicked(true)
    const onMouseUp = () => setClicked(false)

    const handleLinkHoverEvents = () => {
      const links = document.querySelectorAll('a, button, [role="button"], .MuiButtonBase-root, input, textarea')
      links.forEach(link => {
        link.addEventListener('mouseenter', () => setLinkHovered(true))
        link.addEventListener('mouseleave', () => setLinkHovered(false))
      })
    }

    addEventListeners()
    handleLinkHoverEvents()

    // Re-scan for links periodically as content might change
    const interval = setInterval(handleLinkHoverEvents, 2000)

    return () => {
      removeEventListeners()
      clearInterval(interval)
    }
  }, [])

  if (typeof window === 'undefined') return null

  // Disable cursor on mobile/touch devices
  const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0
  if (isTouchDevice) return null

  return (
    <>
      <div
        className={classes.cursorDot}
        style={{
          left: `${position.x}px`,
          top: `${position.y}px`,
          opacity: hidden ? 0 : 1,
          backgroundColor: linkHovered ? '#fff' : '#2DAA67',
          width: clicked ? 6 : linkHovered ? 4 : 8,
          height: clicked ? 6 : linkHovered ? 4 : 8
        }}
      />
      <div
        className={classes.cursorOutline}
        style={{
          left: `${position.x}px`,
          top: `${position.y}px`,
          opacity: hidden ? 0 : 1,
          width: clicked ? 30 : linkHovered ? 60 : 40,
          height: clicked ? 30 : linkHovered ? 60 : 40,
          backgroundColor: linkHovered ? 'rgba(45, 170, 103, 0.2)' : 'transparent',
          borderColor: linkHovered ? 'rgba(45, 170, 103, 1)' : 'rgba(45, 170, 103, 0.4)',
          borderWidth: linkHovered ? '1px' : '2px'
        }}
      />
    </>
  )
}

export default CustomCursor
